import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { Types } from '@grandvisionhq/graphql';
import '@grandvisionhq/utils';
import '../../context/PaymentsUI/context.js';
import { usePaypalClientConfiguration } from '../../context/Paypal/PaypalClientConfigurationContext.js';
import { useInitiatePaypalTransaction } from './use-initiate-paypal-transaction.js';

const useCreatePaypalPaymentEvents = ({ cartId , onPaymentAuthorization , onPaymentTokenReceive , hasSubscription , checkoutType , onClick  })=>{
    const [initiatePaypalTransaction] = useInitiatePaypalTransaction({
        cartId,
        checkoutType: checkoutType || Types.CheckoutType.REGULAR
    });
    const paypalConfig = usePaypalClientConfiguration();
    const createOrder = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const { data , errors  } = yield initiatePaypalTransaction();
        const response = data === null || data === void 0 ? void 0 : data.initiatePaypalTransaction.response;
        if (errors || !response) {
            throw new Error('Could not initiate paypal transaction');
        }
        if (response.__typename !== 'PaypalOrderResponse') {
            throw new Error('Subscription not implemented for create order');
        }
        if (onPaymentTokenReceive) {
            if (response.token) {
                onPaymentTokenReceive(response.token);
            } else {
                throw new Error('Did not receive payment token');
            }
        }
        return response.id;
    }), [
        initiatePaypalTransaction,
        onPaymentTokenReceive
    ]);
    const createBillingAgreement = React.useCallback(swcHelpers.asyncToGenerator(function*() {
        const { data , errors  } = yield initiatePaypalTransaction();
        const response = data === null || data === void 0 ? void 0 : data.initiatePaypalTransaction.response;
        if (errors || !response) {
            throw new Error('Could not initiate paypal transaction');
        }
        if (response.__typename !== 'PaypalSubscriptionResponse') {
            throw new Error('Billing agreement not supported for regular orders');
        }
        return response.billingAgreementTokenId;
    }), [
        initiatePaypalTransaction
    ]);
    const onApprove = React.useCallback(function() {
        var _ref = // Disabling the rule because the onApprove type from react-paypal-js requires a promise
        // eslint-disable-next-line @typescript-eslint/require-await
        swcHelpers.asyncToGenerator(function*(data, actions) {
            try {
                // If we have a subscription we have address validation from checkout page
                if (!actions.order || hasSubscription) {
                    onPaymentAuthorization(data.billingToken);
                } else {
                    var ref, ref1;
                    const details = yield actions.order.get();
                    const shippingAddress = (ref = details.purchase_units[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.shipping) === null || ref1 === void 0 ? void 0 : ref1.address;
                    const { countryCode , postalCode  } = (paypalConfig === null || paypalConfig === void 0 ? void 0 : paypalConfig.addressValidation) || {};
                    if (shippingAddress && (countryCode === null || countryCode === void 0 ? void 0 : countryCode((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.country_code) || '')) && (postalCode === null || postalCode === void 0 ? void 0 : postalCode((shippingAddress === null || shippingAddress === void 0 ? void 0 : shippingAddress.postal_code) || ''))) {
                        onPaymentAuthorization(data.orderID);
                    } else {
                        toast.failed('checkout.payment.paypal.invalidCountry');
                    }
                }
            } catch (e) {
                console.error(e);
            }
        });
        return function(data, actions) {
            return _ref.apply(this, arguments);
        };
    }(), [
        paypalConfig,
        onPaymentAuthorization,
        hasSubscription
    ]);
    return {
        onError: console.error,
        onApprove,
        createOrder: !hasSubscription ? createOrder : undefined,
        createBillingAgreement: hasSubscription ? createBillingAgreement : undefined,
        onClick
    };
};

export { useCreatePaypalPaymentEvents };
//# sourceMappingURL=use-create-paypal-payment-events.js.map
